import { normalizeLanguageCode } from "../../i18n/languages.js";

const CLERK_EMAIL_LOCALE_BY_LANGUAGE = Object.freeze({
  en: "en-US",
  de: "de-DE",
  es: "es-ES",
  fr: "fr-FR",
});

export function resolveCedrumClerkEmailLocale(input) {
  const language = normalizeLanguageCode(input, { includePseudo: true });
  return (
    CLERK_EMAIL_LOCALE_BY_LANGUAGE[language] ||
    CLERK_EMAIL_LOCALE_BY_LANGUAGE.en
  );
}
